export const orderStage = {
  WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
  WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
  WAITING_FOR_CHECK_IN: 'WAITING_FOR_CHECK_IN',
  CHECKED_IN: 'CHECKED_IN',
  AFTER_SALES_INTERVENTION: 'AFTER_SALES_INTERVENTION',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
  REFUNDING: 'REFUNDING',
  COMPLETED: 'COMPLETED',
  SELECTING_PAYMENT_PLAN: 'SELECTING_PAYMENT_PLAN',
};

export const orderSecondaryStage = {
  NON_CONFIRM_IN_TIME: 'NON_CONFIRM_IN_TIME',
  REJECT_BY_LANDLORD: 'REJECT_BY_LANDLORD',
  CANCELLED_BY_SERVICE_TEAM: 'CANCELLED_BY_SERVICE_TEAM',
  CANCEL_BY_LANDLORD: 'CANCEL_BY_LANDLORD',
  ALL_NON_REFUND: 'ALL_NON_REFUND',
  PARTIAL_NON_REFUND: 'PARTIAL_NON_REFUND',
  PENDING_COUNTER_OFFER: 'PENDING_COUNTER_OFFER',
  COUNTER_OFFER_NON_CONFIRM_IN_TIME: 'COUNTER_OFFER_NON_CONFIRM_IN_TIME',
  NO_INVENTORY_AVAILABLE: 'NO_INVENTORY_AVAILABLE',
  NON_SIGN_IN_TIME: 'NON_SIGN_IN_TIME',
  PENDING_GUARANTOR_INFO: 'PENDING_GUARANTOR_INFO',
  NO_NEED_GUARANTOR: 'NO_NEED_GUARANTOR',
  GUARANTOR_PROVIDED: 'GUARANTOR_PROVIDED',
  NON_PAY_IN_TIME: 'NON_PAY_IN_TIME',
  CANCEL_BY_STUDENT: 'CANCEL_BY_STUDENT',
  COUNTER_OFFER_REJECTED_BY_STUDENT: 'COUNTER_OFFER_REJECTED_BY_STUDENT',
  COUNTER_OFFER_ACCEPTED_BY_STUDENT: 'COUNTER_OFFER_ACCEPTED_BY_STUDENT',
};

export const reconciliationOptions = {
  BOOKING_COMPLETED: 'completedAt',
  STUDENT_CHECK_IN: 'finalMoveInDate',
  STUDENT_CHECK_OUT: 'finalMoveOut',
};

export const instantBookOrderStage = {
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  COMPLETED: 'COMPLETED',
  CHECKED_IN: 'CHECKED_IN',
  CANCELLED: 'CANCELLED',
  LOST: 'LOST',
  FILLING_PERSONAL_INFO: 'FILLING_PERSONAL_INFO',
  SIGNING_AGREEMENT: 'SIGNING_AGREEMENT',
  MAKING_PAYMENT: 'MAKING_PAYMENT',
  REFUNDING: 'REFUNDING',
  SELECTING_PAYMENT_PLAN: 'SELECTING_PAYMENT_PLAN',
};

export const instantBookOrderSecondaryStage = {
  NON_SIGN_IN_TIME: 'NON_SIGN_IN_TIME',
  NON_CONFIRM_IN_TIME: 'NON_CONFIRM_IN_TIME',
  NO_INVENTORY_AVAILABLE: 'NO_INVENTORY_AVAILABLE',
  PENDING_GUARANTOR_INFO: 'PENDING_GUARANTOR_INFO',
  REJECT_BY_LANDLORD: 'REJECT_BY_LANDLORD',
  CANCELLED_BY_SERVICE_TEAM: 'CANCELLED_BY_SERVICE_TEAM',
  CANCEL_BY_LANDLORD: 'CANCEL_BY_LANDLORD',
  ALL_NON_REFUND: 'ALL_NON_REFUND',
  PARTIAL_NON_REFUND: 'PARTIAL_NON_REFUND',
  NO_NEED_GUARANTOR: 'NO_NEED_GUARANTOR',
  GUARANTOR_PROVIDED: 'GUARANTOR_PROVIDED',
  NON_PAY_IN_TIME: 'NON_PAY_IN_TIME',
  CANCEL_BY_STUDENT: 'CANCEL_BY_STUDENT',
};

export const orderInstalmentPlanType = {
  FULL_PAYMENT: 'FULL_PAYMENT',
  PAY_QUARTERLY: 'PAY_QUARTERLY',
  PAY_MONTHLY: 'PAY_MONTHLY',
  PAY_WEEKLY: 'PAY_WEEKLY',
  PAY_REMAINDER_AT_ONCE: 'PAY_REMAINDER_AT_ONCE',
};

export const orderCounterOfferDiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  ABSOLUTE: 'ABSOLUTE',
};

export const counterOfferStage = {
  WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
  CANCELLED: 'CANCELLED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  LOST: 'LOST',
};
